import { Adviser } from './interface';

export const mapAdvisersData = (data: Adviser[]) =>
  data.map((adviser) => {
    const { first_name, last_name, fca, firm_name, is_active } = adviser;
    return {
      ...adviser,
      fca_id: fca.id,
      fca_number: fca.number,
      fca_status: fca.is_active,
      lmc_status: is_active,
      name: firm_name,
      fullName: `${first_name} ${last_name}`,
    };
  });
